<template>
  <div class="informar-pago-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Comprobantes y transferencias</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-cash-check</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            
            <v-row>
              <v-col cols="12" md="8" lg="8" class="mx-auto">
                <v-card class="pa-6 rounded-xl border-light shadow-premium" elevation="0">
                  <div class="text-center mb-6">
                    <v-icon size="64" color="primary" class="mb-4">mdi-receipt-text-outline</v-icon>
                    <h2 class="text-h6 font-weight-bold primary-text">Acreditación de Pago</h2>
                    <p class="text-body-2 grey--text">Sube tus comprobantes para que podamos acreditar el pago en tu cuenta.</p>
                  </div>

                  <v-textarea
                    v-model="titulo"
                    label="Indique la/las cuota/s que abonó; y/o detalle su consulta de pagos"
                    required
                    outlined
                    rounded
                    auto-grow
                    rows="3"
                    class="premium-input mb-4"
                    color="primary"
                    placeholder="Ejemplo: Adjunto comprobante de la cuota de Mayo 2024."
                  ></v-textarea>

                  <v-file-input
                    show-size
                    v-model="files"
                    :items="files"
                    multiple
                    counter
                    accept="image/*,.pdf"
                    label="Por favor, agregue Imagen o PDF de su comprobante de pago"
                    outlined
                    rounded
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                    class="premium-input mb-6"
                    color="primary"
                  >
                    <template v-slot:selection="{ text, index }">
                      <v-chip
                        small
                        close
                        @click:close="remove(index)"
                        color="primary lighten-5"
                        text-color="primary darken-2"
                        class="font-weight-bold mr-2 mt-1"
                      >
                        <v-icon left small>mdi-file-document-outline</v-icon>
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>

                  <v-btn
                    color="primary"
                    elevation="2"
                    large
                    block
                    rounded
                    class="font-weight-bold text-none py-6 custom-btn-shadow"
                    @click="addInforme()"
                  >
                    <v-icon left>mdi-send-check</v-icon>
                    Crear informe de pago
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
            
          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "InformarPago",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title: "Informar pago",
    titulo: '',
    files: [],
  }),

  methods: {
    remove(index) {
      this.files.splice(index, 1);
    },

    async addInforme() {
      if(this.titulo.trim() == "") {
        alert('Por favor, indique la cuota que paga');
        return;
      }
      
      if(this.files.length == 0) {
        alert('Por favor, agregue comprobante de pago');
        return;
      }

      var formData = new FormData();
      formData.append('titulo', this.titulo);
      formData.append('cantidadImagen', this.files.length);

      let i = 0;
      for (let file of this.files) {
          formData.append(`imagen_${i}`, file, file.name);
          i++;
      }
      
      let url = "consulta-acreditacion/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.titulo = "";
          this.files = [];
          if (this.$swal) {
             this.$swal({
              title: '¡Enviado!',
              text: 'Tu comprobante de pago ha sido enviado correctamente.',
              icon: 'success',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#1976D2'
            });
          } else {
             alert('¡Enviado! Tu comprobante de pago ha sido enviado correctamente.');
          }
        }).catch(() => {
           if (this.$swal) {
             this.$swal({
              title: 'Error',
              text: 'Ocurrió un error al enviar el comprobante.',
              icon: 'error',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#1976D2'
            });
          } else {
             alert('Error: Ocurrió un error al enviar el comprobante.');
          }
        });
    }
  }
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.informar-pago-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }

.shadow-premium {
  box-shadow: 0 10px 40px -10px rgba(0,0,0,0.08) !important;
}

.custom-btn-shadow {
  box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important;
  transition: all 0.3s ease;
}
.custom-btn-shadow:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px -6px rgba(25, 118, 210, 0.5) !important;
}

/* Form Styles */
.premium-input >>> .v-input__control > .v-input__slot {
  background-color: #ffffff !important;
  border-radius: 16px !important;
}
.premium-input >>> fieldset {
  border-color: rgba(0,0,0,0.08) !important;
}
.premium-input:hover >>> fieldset {
  border-color: rgba(25, 118, 210, 0.4) !important;
}

.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
